export default "__VITE_ASSET__c9coMEd6__"